$.ajax({
    type: "POST",
    url: document.getElementById('downloadCartRoute').value,
    data: {
        onlyCount: 'showOnlyCount',
        url: window.location.href,
        '_token': $('meta[name="csrf-token"]').attr('content')
    },
    dataType: "json",
    success: function (data) {
        if (data.status && data.qtd) {
            let content = "";
            $.each(data.cart, function (index, el) {

                content += `<div class="bagDownload__iten" data-id="${el.id}">
                                <div class="bagDownload__image">
                                    <img src="${el.img}/${el.icon}.png" alt="${el.title}" class="img-fluid">
                                </div>
                                <div class="bagDownload__infos">
                                <p class="bagDownload__infos__title">${el.title}</p>
                                <p class="bagDownload__infos__size">(${el.size})</p>										
                                </div>
                            </div>`;
            });

            if (getCookie('modalDownQual')) {
                $('.qual').fadeIn();
                $('.qual').addClass("valid");
                $('.qual').prop("required", true);
            }

            $('.bagDownload__stage input[name="name"]').val(getCookie('modalDownName'));
            $('.bagDownload__stage input[name="email"]').val(getCookie('modalDownEmail'));
            $('.bagDownload__stage select[name="jaEClienteSoprano"]').val(getCookie('modalDownJaEClienteSoprano'));
            $('.bagDownload__stage input[name="qual"]').val(getCookie('modalDownQual'));

            $('.bagDownload__stage select[name="areaDeAtuacao"]').val(getCookie('modalDownAreaDeAtuacao'));
            $('.bagDownloadFixed__content, .bagDownload__subtitle--item, .bagDownload__btnNext, .bagDownload__btnNext--grey, .bagDownload__more').removeClass('d-none');
            $('.bagDownload__subtitle--noitem').addClass('d-none');
            $('.bagDownloadFixed__number').html(data.qtd);
            $('.bagDownload__itensContent').html(content);
            // $('[data-bagDownload]').addClass('bagDownload--open');
            // $('body').css('overflow-y', 'hidden');
        }
    }
});

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}